import React from 'react'
import Box from '@material-ui/core/Box'
import Skeleton from '@material-ui/lab/Skeleton'
import useStyles from './styles'

const ACTION_COUNT = 4

// Page-level placeholder for the Quick actions card. The card has no data of
// its own, so this is only shown while the dashboard page itself loads.
const QuickActionsSkeleton = () => {
  const classes = useStyles()

  return (
    <Box className={classes.card} data-testid="quick-actions-skeleton">
      <Box className={classes.cardHeader}>
        <Skeleton variant="text" width={110} height={21} />
      </Box>
      <Box className={classes.list}>
        {Array.from({ length: ACTION_COUNT }, (_, index) => (
          <Skeleton
            key={index}
            variant="rect"
            width="100%"
            height={36}
            style={{ borderRadius: 18 }}
          />
        ))}
      </Box>
    </Box>
  )
}

export default QuickActionsSkeleton
